import { render, staticRenderFns } from "./DashboardTenantAdmin.vue?vue&type=template&id=7f78a262&scoped=true"
import script from "./DashboardTenantAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardTenantAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardTenantAdmin.vue?vue&type=style&index=0&id=7f78a262&prod&scoped=true&lang=css"
import style1 from "./DashboardTenantAdmin.vue?vue&type=style&index=1&id=7f78a262&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f78a262",
  null
  
)

export default component.exports